<template>
  <div class="students">
    <div class="top_row">
      <h2 class="title">成员信息</h2>
      <el-upload
        class="btn"
        action="#"
        :show-file-list="false"
        :auto-upload="false"
        :on-change="handleImport"
      >
        <el-button type="primary" size="small" icon="el-icon-upload2"
          >导入</el-button
        >
      </el-upload>
      <el-button
        class="btn"
        type="primary"
        size="small"
        icon="el-icon-download"
        style="margin-right: 10px"
        @click="handleDown"
        >下载模板</el-button
      >
      <el-radio-group
        v-model="status"
        size="small"
        style="float: right; margin-right: 10px"
      >
        <el-radio-button :label="0">全部</el-radio-button>
        <el-radio-button :label="1">已加入团队</el-radio-button>
        <el-radio-button :label="2">未加入团队</el-radio-button>
      </el-radio-group>
    </div>

    <el-table class="student_list" :data="sList" border>
      <el-table-column prop="avatar" label="头像" width="80" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 44px; height: 44px"
            :src="
              scope.row.avatar || require('@/assets/images/icons/icon_me.png')
            "
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="80" align="center">
      </el-table-column>
      <el-table-column prop="username" label="账号" width="120" align="center">
      </el-table-column>
      <el-table-column prop="sno" label="学号" width="120" align="center">
      </el-table-column>
      <el-table-column
        prop="sex"
        label="性别"
        :formatter="sexFormatter"
        width="80"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="score" label="成绩" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.score ? Number(scope.row.score.toFixed(2)) : 0 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="teamName"
        label="所属团队"
        width="150"
        align="center"
        :filters="[{ text: '未加入', value: null }]"
        :filter-method="filterTag"
      >
        <template slot-scope="scope">
          {{ scope.row.teamName || "无" }}
        </template>
      </el-table-column>
      <el-table-column prop="postName" label="岗位" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.postName || "无" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="加入日期"
        :formatter="formatter"
        width="200"
        align="center"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="
              showPass = true;
              params.classUserId = scope.row.classUserId;
            "
            type="text"
            size="small"
          >
            重置密码
          </el-button>
          <el-button
            @click.native.prevent="deleteRow(scope.row.classUserId)"
            type="text"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- <el-dialog
      title="添加学生"
      :visible.sync="showAdd"
      center
      width="50%"
      class="add_student"
    >
      <p class="tips">
        <i class="el-icon-warning-outline"></i>
        <span>请将要添加的学生学号输入并且用回车隔开（每行一个）</span>
      </p>
      <el-input
        type="textarea"
        :autosize="{ minRows: 6 }"
        resize="none"
        placeholder="请输入要添加学生的学号"
        v-model="studentIDs"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false">取 消</el-button>
        <el-button type="primary" @click="addStudent">确 定</el-button>
      </span>
    </el-dialog> -->

    <confirm-dialog
      :show="showConfirm"
      @onConfirm="onConfirm"
      desc="您确定要删除该学生吗？"
    />

    <el-dialog title="重置密码" :visible.sync="showPass" center width="30%">
      <el-input v-model="params.password" placeholder="请输入新密码"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="showPass = false">取 消</el-button>
        <el-button type="primary" size="medium" @click="resetPass"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  studentList,
  delTeam,
  importStudent,
  importMember,
  resetMemberPass,
} from "@/api/student";
import { formatDate } from "@/utils/index";
import confirmDialog from "@/components/confirmDialog/index.vue";

export default {
  components: {
    confirmDialog,
  },
  data() {
    return {
      showAdd: false,
      studentIDs: "",
      showConfirm: false,
      classUserId: null,
      showPass: false,
      params: {
        classUserId: null,
        password: "",
      },
      studentList: [],
      status: 0,
      sList: [],
    };
  },
  created() {
    this.getList();
  },
  watch: {
    status(val) {
      if (val == 0) {
        this.sList = this.studentList;
      } else if (val == 1) {
        this.sList = this.studentList.filter((item) => {
          return item.teamName;
        });
      } else {
        this.sList = this.studentList.filter((item) => {
          return !item.teamName;
        });
      }
    },
  },
  methods: {
    getList() {
      this.$loading.show();
      studentList({ classId: this.$route.query.id }).then(
        ({ code, data, msg }) => {
          this.$loading.hide();
          if (code == 0) {
            this.studentList = data;
            this.sList = data;
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    // 格式化时间
    formatter(row) {
      return formatDate(row.updateTime, "YYYY-MM-DD HH:mm:ss");
    },
    // 性别
    sexFormatter(row) {
      if (row.sex == "UNKNOW") {
        return "未知";
      } else if (row.sex == "MAN") {
        return "男";
      } else {
        return "女";
      }
    },
    filterTag(value, row) {
      return row.teamName === value;
    },
    // 重置密码
    resetPass() {
      this.$loading.show();
      resetMemberPass(this.params).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("密码重置成功");
          this.params.password = "";
          this.showPass = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 删除
    deleteRow(classUserId) {
      this.classUserId = classUserId;
      this.showConfirm = true;
    },
    onConfirm(val) {
      if (val) {
        this.$loading.show();
        delTeam(this.classUserId).then((res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
      this.showConfirm = false;
    },
    // 添加学生
    // addStudent() {
    //   this.$loading.show();
    //   importStudent({
    //     classId: this.$route.query.id,
    //     usernames: this.studentIDs,
    //   }).then((res) => {
    //     this.$loading.hide();
    //     if (res.code == 0) {
    //       this.$store.dispatch("getStudents", {
    //         classId: this.$route.query.id,
    //       });
    //       this.$message.success("导入成功");
    //       this.getList();
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    //   this.showAdd = false;
    // },
    handleDown() {
      window.open(
        `${process.env.VUE_APP_API_DOMAIN}/app/teacher/class/template`,
        "_blank"
      );
    },
    // 导入
    handleImport(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      this.$loading.show();
      importMember({ classId: this.$route.query.id, file: formData }).then(
        (res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.$message.success("导入成功！");
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.students {
  padding: 20px 33px;
  background-color: rgb(255, 255, 255);

  .top_row {
    margin-bottom: 10px;
    // line-height: 40px;
    overflow: hidden;

    .title {
      float: left;
    }

    .btn {
      float: right;
    }
  }

  .add_btn {
    width: 100%;
  }

  ::v-deep .student_list {
    .is-leaf {
      color: #fff;
      background-color: teal;
    }
  }

  .add_student {
    .tips {
      margin-bottom: 10px;
      color: red;

      i {
        margin-right: 5px;
      }
    }

    ::v-deep .el-textarea__inner {
      font-family: inherit;
    }
  }
}
</style>